export const ActionTypes = {
  LOADING: "PRIORITIZE_ACTIONS_LOADING",
  ERROR: "PRIORITIZE_ACTIONS_ERROR",
  SUCCESS: "PRIORITIZE_ACTIONS_SUCCESS",
};
